import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';

import {
  STATS_SET_PERIOD, STATS_INC_PERIOD, STATS_DEC_PERIOD,
  STATS_GET_HISTORY, STATS_GET_COUNT, STATS_GET_WINE_RANKING, STATS_GET_WAF
} from '@/store/actions/stats';

import statsApi from '@/api/stats';
import groupApi from '@/api/group';
import producerApi from '@/api/producer';

/* eslint-disable camelcase */


export const BOTTLE_VOLUME = 75;

const DEFAULT_STATE = {
  period: '',
  period_from: null,
  period_to: null,
  period_label: '',

  history: [],
  wine_ranking: [],
  count: {},
  wallOfFame: {
    city: null,
    client: null,
    wine: null
  }
};

const state = _.merge({}, DEFAULT_STATE);

const getters = {
};

const actions = {
  async [STATS_SET_PERIOD] ({ commit }, period) {
    commit(STATS_SET_PERIOD, period);
  },

  async [STATS_INC_PERIOD] ({ commit }) {
    commit(STATS_INC_PERIOD, 1);
  },

  async [STATS_DEC_PERIOD] ({ commit }) {
    commit(STATS_INC_PERIOD, -1);
  },

  async [STATS_GET_HISTORY] ({ commit, state }, { wine_id, client_id, machine_id } = {}) {
    commit(STATS_GET_HISTORY, await statsApi.getHistory(state.period, state.period_from, state.period_to, wine_id, client_id, machine_id));
  },

  async [STATS_GET_COUNT] ({ commit, state }, { wine_id, client_id, machine_id } = {}) {
    commit(STATS_GET_COUNT, await statsApi.getCount(state.period, state.period_from, state.period_to, wine_id, client_id, machine_id));
  },

  async [STATS_GET_WINE_RANKING] ({ commit, state }, { client_id, machine_id } = {}) {
    axios.all([
      statsApi.getPerformance(state.period, state.period_from, state.period_to, client_id, machine_id),
      producerApi.getProducers()
    ])
      .then(([ranking, producers]) => {
        for (let r of ranking) {
          const p = producers.find(val => val.producer_id === r.producer_id);
          r.producer_name = p ? p.name : '';
        }

        commit(STATS_GET_WINE_RANKING, ranking);
      });
  },

  async [STATS_GET_WAF] ({ commit, state }) {
    const waf = await statsApi.getWallOfFame(state.period, state.period_from, state.period_to);

    if (waf.client) {
      waf.client.group_name = waf.client.group_id ? (await groupApi.getGroup(waf.client.group_id)).name : '';
    }

    if (waf.wine) {
      waf.wine.producer_name = (await producerApi.getProducer(waf.wine.producer_id)).name;
    }

    commit(STATS_GET_WAF, waf);
  }
};

function updatePeriod (state) {
  let period_label;
  let period_to;

  switch (state.period) {
    case 'year':
      period_label = state.period_from.format('YYYY');
      period_to = state.period_from.clone().add(1, 'years');
      break;

    case 'month':
      period_label = state.period_from.format('MMMM YYYY');
      period_to = state.period_from.clone().add(1, 'months');
      break;

    case 'week':
      period_label = state.period_from.format('[Semaine #]WW YYYY');
      period_to = state.period_from.clone().add(1, 'weeks');
      break;

    case 'day':
      period_label = state.period_from.format('LL');
      period_to = state.period_from.clone().add(1, 'days');
      break;
  }

  state.period_label = period_label;
  // Remove small amount of time to avoid duplicate between first and last time elements
  state.period_to = period_to.subtract(1, 'seconds');
}

const mutations = {
  [STATS_SET_PERIOD] (state, period) {
    state.period = period;

    let period_from = moment.utc();
    switch (period) {
      case 'year':
        period_from.startOf('year');
        break;

      case 'month':
        period_from.startOf('month');
        break;

      case 'week':
        period_from.startOf('isoWeek');
        break;

      case 'day':
        period_from.startOf('day');
        break;
    }
    state.period_from = period_from;
    updatePeriod(state);
  },

  [STATS_INC_PERIOD] (state, increment) {
    let period_from = state.period_from.clone();

    switch (state.period) {
      case 'year':
        period_from.add(increment, 'years');
        break;

      case 'month':
        period_from.add(increment, 'months');
        break;

      case 'week':
        period_from.add(increment, 'weeks');
        break;

      case 'day':
        period_from.add(increment, 'days');
        break;
    }
    state.period_from = period_from;
    updatePeriod(state);
  },

  [STATS_GET_HISTORY] (state, data) {
    state.history = data;
  },

  [STATS_GET_WINE_RANKING] (state, data) {
    state.wine_ranking = data;
  },

  [STATS_GET_COUNT] (state, data) {
    state.count = _.merge({}, DEFAULT_STATE.count, data);
  },

  [STATS_GET_WAF] (state, data) {
    state.wallOfFame = _.merge({}, DEFAULT_STATE.wallOfFame, data);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
